export { AvatarGroupItem } from './AvatarGroupItem';
export type {
  AvatarGroupItemProps,
  AvatarGroupItemSlots,
  AvatarGroupItemState,
  AvatarGroupItemBaseProps,
  AvatarGroupItemBaseState,
} from './AvatarGroupItem.types';
export { renderAvatarGroupItem_unstable } from './renderAvatarGroupItem';
export { useAvatarGroupItem_unstable, useAvatarGroupItemBase_unstable } from './useAvatarGroupItem';
export {
  avatarGroupItemClassNames,
  useAvatarGroupItemStyles_unstable,
  useGroupChildClassName,
} from './useAvatarGroupItemStyles.styles';
